<template>
  <!-- Rendered only for white-label tenants; the DentCloud build shows nothing. -->
  <div
    v-if="isCiTenant"
    class="powered-by-dentcloud"
    :class="{ 'powered-by-dentcloud--compact': compact }"
    data-testid="powered-by-dentcloud"
  >
    <span class="powered-by-dentcloud__label">Powered by</span>
    <img
      class="powered-by-dentcloud__logo"
      src="@/assets/img/dentcloud-logo-darkblue.png"
      alt=""
      aria-hidden="true"
    />
    <span class="powered-by-dentcloud__name">DentCloud</span>
  </div>
</template>

<script>
import { resolveTenant } from "@/config/tenant";

const TENANT = resolveTenant({ VUE_APP_TENANT: process.env.VUE_APP_TENANT });

export default {
  name: "PoweredByDentCloud",
  props: {
    // Smaller, single-line variant for the sidebar footer.
    compact: { type: Boolean, default: false },
  },
  data() {
    return { isCiTenant: TENANT.isCi };
  },
};
</script>

<style scoped>
.powered-by-dentcloud {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  line-height: 1;
  color: var(--chrome-ink, #4c4543);
  opacity: 0.75;
  white-space: nowrap;
}
.powered-by-dentcloud__logo {
  height: 16px;
  width: auto;
}
.powered-by-dentcloud__name {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.powered-by-dentcloud--compact {
  font-size: 0.65rem;
}
.powered-by-dentcloud--compact .powered-by-dentcloud__logo {
  height: 13px;
}
</style>
